export enum GenInputType {
    TEXT = 'TEXT',
    SELECT = 'SELECT'
}
